import { Avatar, Box, Divider, Flex, Text } from '@chakra-ui/react';
import Image from 'next/legacy/image';

type Props = {
  name: string;
  role: string;
  text: string;
  logoSrc?: string;
  profileImgSrc?: string;
  width?: number;
};

export function TestimonialCard({
  name,
  role,
  text,
  logoSrc,
  profileImgSrc,
  width
}: Props): JSX.Element {
  return (
    <Flex
      direction="column"
      layerStyle="card"
      mx={4}
      my={7}
      gap={4}
      w={width}
      maxW={{ base: '90vw', md: 'unset' }}
      flex="unset"
      bg="white"
      boxShadow="lg"
    >
      <Flex align="center" justify="space-between">
        <Flex align="center" gap={4}>
          <Box boxSize={12} pos="relative" rounded="full" overflow="hidden">
            {profileImgSrc ? (
              <Image src={profileImgSrc} alt={name} layout="fill" />
            ) : (
              <Avatar name={name} />
            )}
          </Box>

          <Box>
            <Text textStyle="xs-semibold" color="gray.900">
              {name}
            </Text>
            <Text textStyle="xs-normal" color="gray.600">
              {role}
            </Text>
          </Box>
        </Flex>

        {logoSrc && <Image src={logoSrc} alt={role} height={25} width={25} />}
      </Flex>

      <Divider />

      <Text textStyle="sm-normal" color="gray.500">
        {text}
      </Text>
    </Flex>
  );
}
